import React, { Component } from 'react';
// import { NavLink, Link } from 'react-router-dom';
import Button from '../../components/Button';
import { Input, Radio } from '../../components/Input';
import './Form.css';
import { validate } from './Validate.js';
import { submit } from './Submit.js';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class FormSubscribe extends Component {
  state = {
    isValidated: false,
    showFormSuccess: false,
    value: ""
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (validate(this.formEl)) {
      submit(null, false, event, this, this.props.apiUrl, true);
      if(!this.state.showFormSuccess) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'event': 'subscription'});
      }
    }
    this.setState({
      isValidated: true,
      value: this.emailInput.state.value
    });
  }

  handleClick = () => {
    this.setState({
      showFormSuccess: false,
      isValidated: false,
      value: ""
    });
  }

  render() {
    return (
      <form
        noValidate
        ref={form => (this.formEl = form)}
        className={`form ${this.props.modifier ? this.props.modifier : '' } ${this.state.isValidated ? 'form--wasValidated' : ''}`}
        onSubmit={this.handleSubmit}
      >
        {
          !this.props.selectCity &&
          <Input modifier="input--wide input--hidden" label="Город" hidden value={this.props.city.baseCityID} name="city" />
        }
        {
          this.props.activity &&
          <Input modifier="input--wide input--hidden" label="Сфера деятельности" hidden value={this.props.activity.id} name="scope_activity" />
        }
        {
          this.props.selectCity &&
          <React.Fragment>
            <div className="row">
              <div className="col col--12">
                {
                  this.props.city.baseCityID &&
                  <Radio value={this.props.city.baseCityID} label={this.props.city.baseCityPrepositional ? this.props.city.baseCityPrepositional : this.props.city.baseCityName} name="city" id={this.props.city.baseCityID} defaultChecked={true} />
                }
                <Radio value="" label="во всех городах" name="city" id="city" defaultChecked={this.props.city.baseCityID ? false : true} />
              </div>
            </div>
          </React.Fragment>
        }
        {
          this.state.showFormSuccess ?
          <div className="text text--substrate">
            <p role="alert" className="text text--bold">Мы будем отправлять новые вакансии на почту {this.state.value}</p>
            <Button submit link="/" text="Оформить на другую почту" onClick={this.handleClick}modifier="button--xxs" submit />
          </div>
          :
          <React.Fragment>
            <div className="row">
              <div className={`col ${this.props.selectCity ? 'col--6 colVertTablet--12' : 'col--12'}`}>
                <Input ref={input => this.emailInput = input} required modifier="input--wide" label="Эл. почта" name="email" type="email" />
              </div>
            </div>
            <div id="formMessage" className="form__receivedMsg"></div>
            <Button link="/" text="Оформить подписку" modifier="button--marginBottom button--wide-mobile" submit />
          </React.Fragment>
        }
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      baseCityName: state.baseCityName
    };
};

export default withRouter(connect(mapStateToProps)(FormSubscribe));




// WEBPACK FOOTER //
// ./src/components/Form/FormSubscribe.js